import { useForm } from "react-hook-form";
import VendorSubUserRequestModel from "../../../models/company/vendorUser/request/VendorSubUserRequestModel";
import { OBJECT_NAME_RULE, EMAIL_RULE, MOBILE_NUMBER_RULE } from "../../../utils/validation-utils";
import toasterUtils from "../../../utils/toaster-utils";
import { Button, FormControl, TextField } from "@mui/material";

interface VendorSubUserProps {
    objVendorSubUser: VendorSubUserRequestModel;
    actionType: string;
    onCloseVendorSubUser: () => void;
    onVendorSubUserSave: (objVendorSubUser: VendorSubUserRequestModel) => void;
}

const VendorSubUserCreateComponent = (props: VendorSubUserProps) => {
    const {
        register,
        handleSubmit,
        formState: { errors, isValid },
    } = useForm<VendorSubUserRequestModel>({
        mode: "onChange",
        defaultValues: props.objVendorSubUser
    });

    const onSubmit = (formData: VendorSubUserRequestModel) => {
        if (!isValid) {
            toasterUtils.showError("Please fill all mandatory fields");
            return;
        }
        formData.vendorUserName = formData.vendorEmailId;
        props.onVendorSubUserSave(formData);
    }

    return (
        <form className="contact quform" onSubmit={handleSubmit(onSubmit)}>
            <div className="row">
                <div className="col-md-6">
                    <FormControl fullWidth margin="normal" error={!!errors.vendorName}>
                        <TextField label="Name" size="small"
                            {...register("vendorName", OBJECT_NAME_RULE)} error={!!errors.vendorName} helperText={errors.vendorName?.message} placeholder="Name" autoComplete="off" required />
                    </FormControl>
                </div>
                <div className="col-md-6">
                    <FormControl fullWidth margin="normal" error={!!errors.vendorEmailId}>
                        <TextField type="email" label="Email" size="small"
                            {...register("vendorEmailId", EMAIL_RULE)} error={!!errors.vendorEmailId} helperText={errors.vendorEmailId?.message} placeholder="Email/User Name" autoComplete="off" required />
                    </FormControl>
                </div>
            </div>
            <div className="row">
                <div className="col-md-6">
                    <FormControl fullWidth margin="normal" error={!!errors.vendorPhoneNumber}>
                        <TextField type="tel" label="Mobile Number" size="small"
                            {...register("vendorPhoneNumber", MOBILE_NUMBER_RULE)} error={!!errors.vendorPhoneNumber} helperText={errors.vendorPhoneNumber?.message} placeholder="Mobile Number" autoComplete="off" required />
                    </FormControl>
                </div>
            </div>
                <div className="text-end">
                    <Button variant="contained" color="success" type="submit" disabled={!isValid}>
                        Save
                    </Button>
                    <Button variant="contained" color="error" className="m-l-xxs" type="button" onClick={props.onCloseVendorSubUser}>
                        Close
                    </Button>
                </div>
        </form>
    );
};
export default VendorSubUserCreateComponent;